export default __webpack_public_path__ + "static/419058413-capace_1920x800-2f13c75920f36d3773c3f64d56ac7a9e.jpg";